/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";

/**
 * Standard error response object
 */
export type GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdErrorResponseData =
  {
    error: string;
    code?: string | undefined;
    details?: any | null | undefined;
  };

/**
 * Standard error response object
 */
export class GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdErrorResponse
  extends Error
{
  error: string;
  code?: string | undefined;
  details?: any | null | undefined;

  /** The original data that was passed to this error instance. */
  data$:
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdErrorResponseData;

  constructor(
    err:
      GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdErrorResponseData,
  ) {
    const message = "message" in err && typeof err.message === "string"
      ? err.message
      : `API error occurred: ${JSON.stringify(err)}`;
    super(message);
    this.data$ = err;

    this.error = err.error;
    if (err.code != null) this.code = err.code;
    if (err.details != null) this.details = err.details;

    this.name =
      "GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdErrorResponse";
  }
}

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdErrorResponse$inboundSchema:
  z.ZodType<
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdErrorResponse,
    z.ZodTypeDef,
    unknown
  > = z.object({
    error: z.string(),
    code: z.string().optional(),
    details: z.nullable(z.any()).optional(),
  })
    .transform((v) => {
      return new GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdErrorResponse(
        v,
      );
    });

/** @internal */
export type GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdErrorResponse$Outbound =
  {
    error: string;
    code?: string | undefined;
    details?: any | null | undefined;
  };

/** @internal */
export const GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdErrorResponse$outboundSchema:
  z.ZodType<
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdErrorResponse$Outbound,
    z.ZodTypeDef,
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdErrorResponse
  > = z.instanceof(
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdErrorResponse,
  )
    .transform(v => v.data$)
    .pipe(z.object({
      error: z.string(),
      code: z.string().optional(),
      details: z.nullable(z.any()).optional(),
    }));

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdErrorResponse$ {
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdErrorResponse$inboundSchema` instead. */
  export const inboundSchema =
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdErrorResponse$inboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdErrorResponse$outboundSchema` instead. */
  export const outboundSchema =
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdErrorResponse$outboundSchema;
  /** @deprecated use `GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdErrorResponse$Outbound` instead. */
  export type Outbound =
    GetApiLeadScraperMicroserviceApiV1WorkspacesWorkspaceIdWorkflowsIdErrorResponse$Outbound;
}
